module.exports = __webpack_public_path__ + "img/BE0424025008.ac142ddd.png";